import { render, staticRenderFns } from "./tableBaukPo.vue?vue&type=template&id=45f06764&scoped=true"
import script from "./tableBaukPo.vue?vue&type=script&lang=js"
export * from "./tableBaukPo.vue?vue&type=script&lang=js"
import style0 from "./tableBaukPo.vue?vue&type=style&index=0&id=45f06764&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f06764",
  null
  
)

export default component.exports